import React from "react";
import { Card } from "react-bootstrap";
import { FiAlertTriangle } from "react-icons/fi";
import IconHeader from "components/IconHeader";
import IconSubheader from "components/IconSubheader";

interface SignupLinkCardProps {
  headerText: string;
  children: React.ReactNode;
}

export const SalesEmailLink = () => (
  // the global a.link style pads the left, which opens a gap mid-sentence
  <a
    className={"link"}
    href="mailto:sales@iconsavingsplan.com"
    style={{ paddingLeft: 0 }}
  >
    sales@iconsavingsplan.com
  </a>
);

const SignupLinkCard = ({
  headerText,
  children,
}: SignupLinkCardProps): React.JSX.Element => {
  return (
    <Card
      className={"signup-link-card"}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="icon-container"
        style={{
          marginTop: 12,
        }}
      >
        <FiAlertTriangle size={32} color={"#f2a766"} />
      </div>
      <Card.Body style={{ textAlign: "center", paddingTop: 8 }}>
        <IconHeader variant="labelHeader" headerText={headerText} />
        <IconSubheader>{children}</IconSubheader>
      </Card.Body>
    </Card>
  );
};

export default SignupLinkCard;
